/**
 * 求人検索一覧（`JobsPage`）にマッチするルートの `path` か。
 * `/jobs/:id(\\d+)` の求人詳細は除外する。
 */
export function isJobSearchListRoutePath(path: string): boolean {
  // 詳細は除外
  if (/^\/jobs\/(agent|direct)\/\d+$/.test(path)) return false;
  if (/^\/jobs\/\d+$/.test(path)) return false;

  if (path === '/jobs') return true;
  if (path === '/jobs/agent' || path.startsWith('/jobs/agent/')) return true;
  if (path === '/jobs/direct' || path.startsWith('/jobs/direct/')) return true;
  return false;
}
